<template>
  <el-container direction="vertical">
    <task-new :isVisible.sync="showNewModal" @taskSubmitted="taskSubmitted" />
    <el-row>
      <el-col :span="24" style="display: flex; justify-content: space-between">
        <el-button-group>
          <el-button
            class="button"
            icon="el-icon-delete"
            @click="deleteTask"
            v-if="taskId && envRights !== 'Run'"
            >Delete</el-button
          >
          <el-button
            class="button"
            icon="el-icon-check"
            @click="saveTask"
            v-if="envRights !== 'Run'"
            >Save</el-button
          >
          <el-button
            class="button"
            icon="el-icon-circle-check"
            @click="runTask"
            v-if="taskId"
            >{{ envRights === "Run" ? "Run" : "Save & Run" }}</el-button
          >
          <el-button
            class="button"
            @click="showNewModal = true"
            icon="el-icon-copy-document"
            v-if="taskId && envRights !== 'Run'"
            >Duplicate
          </el-button>
          <el-button
            class="button"
            icon="el-icon-video-play"
            v-if="!taskId && envRights !== 'Run'"
            @click="runQuickTask"
            >Quick Run
          </el-button>
        </el-button-group>
        <el-button-group>
          <el-checkbox
            :checked="taskViewControlObjects"
            @change="viewControlObjectsUpdated"
            :disabled="envRights === 'Run'"
            >View Control Objects</el-checkbox
          >
        </el-button-group>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form label-position="top">
          <el-form-item label="Name" v-if="taskName">
            <el-input
              @blur="nameUpdated"
              v-model="$v.name.$model"
              :class="{ error: checkValid && $v.name.$invalid }"
              :disabled="envRights === 'Run'"
            />
          </el-form-item>
          <el-form-item label="Task Type">
            <el-select
              filterable
              v-model="type"
              style="width: 100%"
              @change="typeSelected"
              :disabled="envRights === 'Run'"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form label-position="top">
          <el-form-item label="Description (Optional)" v-if="taskName">
            <el-input
              @blur="descriptionUpdated"
              v-model="description"
              :disabled="envRights === 'Run'"
              type="textarea"
            />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import { required, requiredIf } from "vuelidate/lib/validators";
import TaskNew from "../modals/TaskNew";

export default {
  props: {
    taskName: String,
    taskDescription: String,
    taskType: String,
    taskCheckValid: Boolean,
    taskViewControlObjects: Boolean,
  },
  components: { TaskNew },
  data() {
    return {
      showNewModal: false,
      name: this.taskName,
      description: this.taskDescription,
      type: this.taskType,
      checkValid: false,
      options: [
        {
          value: "Copy",
          label: "Copy",
        },
        {
          value: "Move",
          label: "Move",
        },
        {
          value: "Zero Out",
          label: "Zero Out",
        },
      ],
    };
  },
  watch: {
    taskName(value) {
      this.name = value;
    },
    taskDescription(value) {
      this.description = value;
    },
    taskType(value) {
      this.type = value;
    },
    taskCheckValid(value) {
      this.checkValid = value;
    },
  },
  methods: {
    /**
     * Updates the interface after modifying the task name
     * @function
     */
    nameUpdated() {
      this.$emit("nameUpdated", this.name);
    },
    viewControlObjectsUpdated() {
      this.$emit("viewControlObjectsUpdated");
    },
    /**
     * Updates the interface after modifying the task description
     * @function
     */
    descriptionUpdated() {
      this.$emit("descriptionUpdated", this.description);
    },
    /**
     * Updates the interface after selecting a task type
     * @function
     * @param {String} type - Type of the task
     */
    typeSelected(type) {
      console.log("type Selected 1");
      this.$emit("typeSelected", type);
    },
    /**
     * Updates the interface after saving a new task
     * @function
     */
    taskSubmitted({ name, description }) {
      this.$emit("saveTask", { name, description });
    },
    /**
     * Updates the interface after saving a task
     * @function
     */
    saveTask() {
      if (this.taskId) {
        this.$emit("saveTask", {});
      } else {
        this.showNewModal = true;
      }
    },
    /**
     * Updates the interface after running a task
     * @function
     */
    runTask() {
      this.$emit("runTask");
    },
    /**
     * Updates the interface after running a quick task
     * @function
     */
    runQuickTask() {
      this.$emit("runQuickTask");
    },
    /**
     * Updates the interface after deleting a task
     * @function
     */
    deleteTask() {
      if (confirm(`Are you sure you want to delete the "${this.name}" task?`)) {
        this.$emit("deleteTask");
      }
    },
  },
  computed: {
    ...mapState(["taskId", "envRights"]),
  },
  validations() {
    return {
      name: {
        required: requiredIf(() => {
          return this.taskName;
        }),
      },
      type: { required },
    };
  },
};
</script>

<style scoped>
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
  margin-bottom: 15px;
  padding: 10px 15px;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.el-textarea :deep(.el-textarea__inner) {
  resize: none;
  height: 125px !important;
  min-height: 125px !important;
}
</style>
